import { css, type Interpolation } from 'styled-components'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

export const DURATION_TAB_SELECTED_BACKGROUND = 'color-mix(in srgb, var(--palette-highlight-primary-dark-background), var(--palette-neutral-control-color-white) var(--palette-neutral-control-opacity-8))'

export const durationTabRebrandCaretStyles = css`
  body.${REBRAND_PALETTE_CLASS} && {
    border-top-color: var(--duration-tab-caret-color, ${DURATION_TAB_SELECTED_BACKGROUND});
    color: var(--duration-tab-caret-color, ${DURATION_TAB_SELECTED_BACKGROUND});
  }
`

export const durationTabRebrandOptionStyles = (caret: Interpolation<object>) => css`
  body.${REBRAND_PALETTE_CLASS} & {
    --duration-tab-selected-background: ${DURATION_TAB_SELECTED_BACKGROUND};
    --duration-tab-selected-hover-background: ${DURATION_TAB_SELECTED_BACKGROUND};
    --duration-tab-caret-color: var(--duration-tab-selected-background);
  }

  body.${REBRAND_PALETTE_CLASS} &.selected,
  body.${REBRAND_PALETTE_CLASS} &.selected:focus {
    color: var(--palette-highlight-primary-dark-contrast);
    background-color: var(--duration-tab-selected-background);

    ${caret} {
      border-top-color: var(--duration-tab-selected-background);
      color: var(--duration-tab-selected-background);
    }
  }

  ${mediaHoverable} {
    body.${REBRAND_PALETTE_CLASS} &.selected:hover {
      color: var(--palette-highlight-primary-dark-contrast);
      background-color: var(--duration-tab-selected-hover-background);
      --duration-tab-caret-color: var(--duration-tab-selected-hover-background);

      ${caret} {
        border-top-color: var(--duration-tab-selected-hover-background);
        color: var(--duration-tab-selected-hover-background);
      }
    }
  }

  body.${REBRAND_PALETTE_CLASS} &:hover,
  body.${REBRAND_PALETTE_CLASS} &:focus {
    color: var(--palette-highlight-primary-dark-contrast);
    background-color: var(--palette-highlight-primary-dark-background);
  }
`
